import {UseCase} from '@s-ui/domain'

/**
 * @class
 * @implements SendEmailValidationUseCase UseCase
 */

export default class SendEmailValidationUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {SendEmailNotificationsService} deps.sevice
   */
  constructor({service}) {
    super()
    this._service = service
  }

  /**
   * @return {Promise}
   */
  execute() {
    return this._service.execute()
  }
}
